import React from "react";
import "./Contact_Us.css";
import Contact_Form from "./contact_form/Contact_Form";
import Common_Banner from "../common-components/common_banner/Common_Banner";
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";
import Heading_title from "../common-components/common-title/heading-title/Heading_title";
import WhatsappChatbot from "../common-components/chatbot/Chatbot";

const Contact_Us = () => {
  return (
    <div className="Contact_Us">
         <WhatsappChatbot/>
      {/* <Common_Banner imgSrc="/assets/images/contact_us/banner.png"/> */}
       <Common_Banner_2
        imgSrc="/assets/images/home/commng-soon/agri_bg.png"
        title_text="Contact Us"
      />
      <div className="container">
    <Heading_title title={"Contact Us"}  className="container"/></div>
      <Contact_Form />
    </div>
  );
};

export default Contact_Us;
